import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

/**
 * @title Dialog Overview
 */
@Component({
  selector: 'hc-delete-dialog',
  template:
  `
     <div fxLayout="column"  style="padding: 15px">
           <p fxFlex>
               <!--<mat-icon>delete_forever</mat-icon>-->{{ confirmText | trans }}
           </p>
           <div fxFlex="none" fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="end center">
               <button mat-raised-button (click)="clickNo()">{{ 'common.no' | trans }}</button>
               <button mat-raised-button color="primary" (click)="clickYes()" >{{ 'common.yes' | trans }}</button>
           </div>
     </div>
      `
})

export class DeleteDialogComponent {

    public confirmText = 'admin.web.delete-question';

  constructor(
    public dialogRef: MatDialogRef<DeleteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
        if (!!data && data.confirmText !== null) {
            this.confirmText = data.confirmText;
        }
    }

    clickYes(): void {
        this.data = true;
        this.dialogRef.close(true);
    }

    clickNo(): void {
        this.data = false;
        this.dialogRef.close(false);
    }

}
